/** @typedef {import('../User/OrgUser').OrgUser} OrgUser */

/**
 * @typedef {Object} GroupType
 * @property {string} group_id
 * @property {string} [group_name]
 * @property {boolean} allow_group_location_tracking
 * @property {OrgUser[]} group_value
 * @property {string[]} connect_user_auth_ids
 * @property {string[]} ops_user_auth_ids
 * @property {string[]} respond_user_auth_ids
 */

/**
 * Represents an organization group.
 */
class Group {
  /**
   * Create a Group
   * @param {Object} params
   * @param {string} params.group_id
   * @param {string} params.group_name
   * @param {boolean} [params.allow_group_location_tracking=true]
   * @param {OrgUser[]} [params.group_value=[]]
   * @param {string[]} [params.connect_user_auth_ids=[]]
   * @param {string[]} [params.ops_user_auth_ids=[]]
   * @param {string[]} [params.respond_user_auth_ids=[]]
   */
  constructor({
    group_id,
    group_name,
    allow_group_location_tracking = true,
    group_value = [],
    connect_user_auth_ids = [],
    ops_user_auth_ids = [],
    respond_user_auth_ids = [],
  }) {
    /** @type {string} */
    this.group_id = group_id;
    /** @type {string} */
    this.group_name = group_name;
    /** @type {boolean} */
    this.allow_group_location_tracking = allow_group_location_tracking;
    /** @type {OrgUser[]} */
    this.group_value = group_value;
    /** @type {string[]} */
    this.connect_user_auth_ids = connect_user_auth_ids;
    /** @type {string[]} */
    this.ops_user_auth_ids = ops_user_auth_ids;
    /** @type {string[]} */
    this.respond_user_auth_ids = respond_user_auth_ids;
  }
}

export default Group;
